<template>
  <div>
    <b-datepicker
      id="dashboard-date-filter"
      v-model="dates"
      locale="es-ES"
      placeholder="Clic para seleccionar"
      icon="calendar"
      icon-pack="fa"
      range
      :mobile-native="false"
      trap-focus
      :date-formatter="dateFormatter"
      rounded
      @input="emitRangeDateChangeEvent" />
  </div>
</template>

<script>
import { setDateOfMonth } from '@/infrastructure/date';

const firstDayOfMonth = 1;
const esLocale = 'es-ES';

const firstDateOfMonth = setDateOfMonth(new Date(), firstDayOfMonth).toString();
const defaultStartDate = new Date(firstDateOfMonth);
const defaultEndDate = new Date();
const defaultRangeDate = [defaultStartDate, defaultEndDate];

export default {
  name: 'DashboardFilter',
  props: {
    cache: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dates: this.cache && this.$store.state.evaluationDateFilter ? this.$store.state.evaluationDateFilter : defaultRangeDate
    };
  },
  mounted() {
    this.emitRangeDateChangeEvent();
  },
  methods: {
    emitRangeDateChangeEvent() {
      this.$emit('dashboard-range-date-change', this.dates);
    },
    dateFormatter(dates) {
      function formatDate(dateIn) {
        const date = new Date(dateIn);
        const day = date.toLocaleString(esLocale, { day: '2-digit' });
        const month = date.toLocaleString(esLocale, { month: 'short' });
        const year = date.toLocaleString(esLocale, { year: 'numeric' });
        return `${day} ${month} ${year}`;
      }
      return `${formatDate(dates[0])} - ${formatDate(dates[1])}`;
    }
  }
};
</script>

<style scoped>

</style>
